import EventBus from '@/event-bus'

export default {
  handle(data) {
    EventBus.$emit('permission-updated', data.permission)
  },
}
